import React from "react"
import styled from "styled-components"
import theme from "../../../styles/theme"
import headingStyles from "./headingStyles"

const { colors, breakPoints: { screenQuery } } = theme

const H6 = styled.h6(headingStyles, `
  font-size: 20px;
  line-height: 22px;
  ${screenQuery.large}{
    font-size: 18px;
    line-height: 20px;
  }
  ${screenQuery.small}{
    font-size: 16px;
    line-height: 18px;
  }
`)

export default ({
  children,
  ...props
}) => (
    <H6
      {...props}
    >
      {children}
    </H6>
  )
